import { withMetadata } from '../metadata'
import { parsePhoneNumberFromString as _parsePhoneNumberFromString } from '../../core/index'

export function parsePhoneNumberFromString() {
	return withMetadata(_parsePhoneNumberFromString, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/parsePhoneNumberFromString.js
// module id = K0uY
// module chunks = 0 1